var map = {
	"./acunit.png": "667f",
	"./bedside.png": "527a",
	"./bookshelf.png": "9265",
	"./coffeetable.png": "494b",
	"./desk.png": "c3e9",
	"./dresser.png": "c7e4",
	"./frame.png": "5996",
	"./logo-large.png": "e2bc",
	"./logo.png": "9d64",
	"./mail.png": "e9ce",
	"./phone.png": "1e37",
	"./plane-engine.png": "be4a",
	"./plate.png": "a500",
	"./sink.png": "84c3",
	"./soda-can.png": "7a39",
	"./sofa.png": "d4f0",
	"./variants/bedside-var-01.png": "11c7",
	"./variants/bedside-var-02.png": "a6ed",
	"./variants/bedside-var-03.png": "7021",
	"./variants/bookshelf-var-01.png": "ac91",
	"./variants/bookshelf-var-02.png": "0dab",
	"./variants/coffeetable-var-01.png": "4032",
	"./variants/coffeetable-var-02.png": "6cf9",
	"./variants/coffeetable-var-03.png": "803d",
	"./variants/desk-var-01.png": "8901",
	"./variants/desk-var-02.png": "af33",
	"./variants/dresser-var-01.png": "3524",
	"./variants/dresser-var-02.png": "3f94",
	"./variants/dresser-var-03.png": "d69a",
	"./variants/plate-var-01.png": "8cac",
	"./variants/plate-var-02.png": "cc0d",
	"./variants/sink-unit-var-01.png": "9cf5",
	"./variants/sink-unit-var-02.png": "cbee",
	"./variants/sofa-fabric.png": "c2f6",
	"./variants/sofa-leather.png": "0260"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";